import { http } from "./client";
import type { PageParams } from "@/types/api";
import type { Holiday, HolidayType } from "@/types/domain";

export interface HolidayInput {
  name: string;
  date: string;
  type?: HolidayType;
  description?: string;
  is_paid?: boolean;
  department_ids?: string[];
  // locations restricts the holiday to specific work locations (branch/
  // location scoping) - mirrors department_ids exactly: empty/omitted means
  // "every location".
  locations?: string[];
}

export const holidaysApi = {
  list: (year: number, params: PageParams = {}) => http.getPage<Holiday>("/holidays", { year, ...params }),
  create: (input: HolidayInput) => http.post<Holiday>("/holidays", input),
  update: (id: string, input: Partial<HolidayInput>) => http.put<Holiday>(`/holidays/${id}`, input),
  remove: (id: string) => http.delete<void>(`/holidays/${id}`),

  // ---- Employee Self Service ----
  // The caller's own applicable holidays (department/location scope), each
  // showing whether they've selected it - only meaningful for a
  // type: "optional" holiday, which otherwise never counts toward
  // attendance for that employee (see backend HolidayService.
  // ListForEmployee/SelectOptional).
  mine: (year: number) => http.get<Holiday[]>("/employee/self/holidays", { year }),
  select: (id: string) => http.post<Holiday>(`/employee/self/holidays/${id}/select`),
  unselect: (id: string) => http.delete<void>(`/employee/self/holidays/${id}/select`),
};
